<h3 *ngIf="!collapsed()"><b>Select Vessel</b></h3>

<div class="vessel-info-grid">
	<h6 class="mt-0"
		style="grid-column: 1 / span 2;">
		GENERAL
	</h6>
	<div>
		<kendo-label [text]="'Name'"
					 [ngClass]="!!state().vessel() ? 'text-grey' : 'text-red'">
			<kendo-combobox [data]="vessels()"
							[valuePrimitive]="false"
							[valueField]="'id'"
							[textField]="'name'"
							[clearButton]="false"
							[(value)]="state().vessel"
							(valueChange)="onVesselSelected()"
							[fillMode]="'outline'"
							[popupSettings]="{ width: 'auto'}"
							[disabled]="collapsed()"
							[class.border-red]="!state().vessel()">
				<ng-template kendoComboBoxItemTemplate let-dataItem>
					{{ dataItem.name }}
					<ng-container *ngIf="dataItem.vesselType || dataItem.mmsi || dataItem.imo">
						(
						<ng-container *ngIf="dataItem.vesselType">{{ dataItem.vesselType }}</ng-container>
						<ng-container *ngIf="dataItem.vesselType && (dataItem.mmsi || dataItem.imo)">, </ng-container>

						<ng-container *ngIf="dataItem.mmsi">{{ dataItem.mmsi }}</ng-container>
						<ng-container *ngIf="dataItem.mmsi && dataItem.imo">, </ng-container>

						<ng-container *ngIf="dataItem.imo">{{ dataItem.imo }}</ng-container>
						)
					</ng-container>
				</ng-template>
				<ng-template kendoComboBoxValueTemplate let-dataItem>
					{{ dataItem.name }}
					<ng-container *ngIf="dataItem.vesselType || dataItem.mmsi || dataItem.imo">
						(
						<ng-container *ngIf="dataItem.vesselType">{{ dataItem.vesselType }}</ng-container>
						<ng-container *ngIf="dataItem.vesselType && (dataItem.mmsi || dataItem.imo)">, </ng-container>

						<ng-container *ngIf="dataItem.mmsi">{{ dataItem.mmsi }}</ng-container>
						<ng-container *ngIf="dataItem.mmsi && dataItem.imo">, </ng-container>

						<ng-container *ngIf="dataItem.imo">{{ dataItem.imo }}</ng-container>
						)
					</ng-container>
				</ng-template>
			</kendo-combobox>
		</kendo-label>

	</div>
	<pmis3-vessel-visit-detail-labelled-information [label]="'IMO'"
													[value]="state().vessel()?.imo"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Call Sign'"
													[value]="state().vessel()?.callSign"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'MMSI'"
													[value]="state().vessel()?.mmsi"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Type'"
													[value]="state().vessel()?.vesselType"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Flag Registry'"
													[value]="state().vessel()?.flagRegistry"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Year Built'"
													[value]="state().vessel()?.yearOfBuild"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Port Of Registry'"
													[value]="state().vessel()?.portOfRegistryName"></pmis3-vessel-visit-detail-labelled-information>
</div>

<div class="vessel-info-grid">
	<h6 class="mt-0"
		style="grid-column: 1 / span 2;">
		SPECIFICATIONS
	</h6>
	<pmis3-vessel-visit-detail-labelled-information [label]="'LOA'"
													[value]="state().vessel()?.loa"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Beam'"
													[value]="state().vessel()?.beam"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Max Beam'"
													[value]="state().vessel()?.maxBeam"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Summer Draught'"
													[value]="state().vessel()?.draft"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Length Between Perpendiculars'"
													[value]="state().vessel()?.lbp"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'Bridge to Bow'"
													[value]="state().vessel()?.bridgeToBow"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'GT'"
													[value]="state().vessel()?.gt"></pmis3-vessel-visit-detail-labelled-information>
	<pmis3-vessel-visit-detail-labelled-information [label]="'NT'"
													[value]="state().vessel()?.nt"></pmis3-vessel-visit-detail-labelled-information>
</div>
<div class="vessel-info-grid"
	 [ngStyle]="{'grid-template-columns': collapsed() ? '1fr' : 'repeat(2, 1fr)'}">
	<!-- <div>
		<h6 class="mt-0">VESSEL ORGANIZATION</h6>

		<ng-container *ngFor="let agency of vessel()?.agencies">
			<pmis3-vessel-visit-detail-organization [readonly]="true"
													[organization]="agency">
			</pmis3-vessel-visit-detail-organization>
		</ng-container>
	</div> -->
	<div class="d-flex flex-wrap"
		 style="gap:8px 12px;">
		<h6 class="m-0 w-100">VESSEL ORGANIZATION</h6>
		<ng-container *ngFor="let agency of state().vessel()?.agencies; let i = index">
			<div style="flex: 0 0 49%; max-width:50%">
				<pmis3-vessel-visit-detail-organization [readonly]="true"
														[organization]="agency">
				</pmis3-vessel-visit-detail-organization>
			</div>
		</ng-container>
	</div>
	<!-- <div>
		<div class="radio-option"
			 [ngClass]="{'border-green': informationConfirmation() === true }">
			<input #confirm
				   type="radio"
				   kendoRadioButton
				   [value]="true"
				   [(ngModel)]="informationConfirmation"
				   (change)="onConfirmationChange($event)"
				   [disabled]="disableRadioButton()">
			<kendo-icon name="check-circle"
						class="text-green ml-2 mr-1"></kendo-icon>
			<kendo-label [for]="confirm"
						 [text]="'I confirm that this information is correct.'"
						 class="line-height-1">
			</kendo-label>
		</div>
		<div class="radio-option">
			<input #dispute
				   type="radio"
				   kendoRadioButton
				   [value]="false"
				   [(ngModel)]="informationConfirmation"
				   (change)="onConfirmationChange($event)"
				   [disabled]="!vessel()"
				   [disabled]="disableRadioButton()">
			<kendo-icon name="close-circle"
						class="text-red ml-2 mr-1"></kendo-icon>
			<kendo-label [for]="dispute"
						 [text]="'I dispute this information. Comments are required.'"
						 class="line-height-1">
			</kendo-label>
		</div>
	</div> -->
</div>